<template>
    <div>
        <b-table
            striped
            hover
            show-empty
            empty-text="Sem registros encontrados"
            :fields="table.headers"
            :items="table.records"
            class="text-center"
        >
            <template #cell(created_at)="data">
                {{formatDate(data.item.created_at)}}
            </template>
            <template #cell(status)="data">
                {{statusEnum(data.item.status)}}
            </template>
        </b-table>
    </div>
</template>
<script>
import { mapState } from "vuex";
import LogCoinStatus from '../../enums/LogCoinStatus';
export default {
    data() {
        return {
            LogCoinStatus,
            table: {
                headers: [
                    {
                        key: 'id',
                        thClass: 'd-none',
                        tdClass: 'd-none',
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: false,
                    },
                    {
                        key: 'description',
                        label: 'Descrição ',
                        sortable: false,
                    },
                    {
                        key: 'created_at',
                        label: 'Data',
                        sortable: false,
                    },
                ],
                records: [],
            },
        }
    },

    computed: {
    ...mapState(['token', 'dadosUsuario'])
},

    mounted() {
        this.pushLog();
    },

    methods: {
        pushLog() {
            this.$store.dispatch('startLoader');
            this.$store.dispatch('balconista/puxarLog', this.dadosUsuario.id)
            .then((resp) => {
                this.table.records = resp.data.data;
            })
            .catch(() => {
                this.makeToast('Oopss', 'Houve um erro ao trazer os logs!', 'danger')
            })
            .finally(() => {
                this.$store.dispatch('endLoader')
            });
        },

        statusEnum(status) {
            if (status == this.LogCoinStatus.APROVADO) {
                return "Aprovado!";
            }
            if (status == this.LogCoinStatus.ENTRADA) {
                return "Entrada!";
            }
            if (status == this.LogCoinStatus.SOLICITADO) {
                return "Aguardando aprovação";
            }
            if (status == this.LogCoinStatus.REJEITADO) {
                return "Rejeitado";
            }
        },

        formatMoneyUn(value) {
            var money = parseFloat(value);
            return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
        },

        formatDate(date) {
            return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        },
    }
}
</script>
<style scoped>

</style>